import * as React from "react";
import { wopiViewerStore } from "Stores/WOPIViewerStore";
import { observer } from "mobx-react";
import { Loader } from "./General/Loader";
import { ViewerModal } from "./ViewerModal";
/**
 * For description of WOPI viewer integration: https://wopi.readthedocs.io/en/latest/hostpage.html#host-page-example
 */

class WOPIViewerIframeClass extends React.Component {
  frameHolder: HTMLDivElement;
  componentDidMount() {
    this.handleLoadWOPI();
  }

  createInput = (name: string, value: string, form: HTMLFormElement) => {
    const input = document.createElement("input");
    input.type = "text";
    input.name = name;
    input.value = value;
    form.appendChild(input);
  };

  prepareWopiForm(tokenInfo: API_WopiTokenInfo) {
    const form = document.createElement("form");
    form.style.display = "none";
    form.method = "POST";
    form.action = tokenInfo.url;
    form.target = "office-frame";
    this.createInput("access_token", tokenInfo.accessToken, form);
    this.createInput("access_token_ttl", tokenInfo.accessTokenTtl, form);
    return form;
  }

  prepareWopiIframe() {
    const officeFrame = document.createElement("iframe");
    officeFrame.name = "office-frame";
    officeFrame.id = "office-frame";
    officeFrame.title = "Microsoft Office Online";
    officeFrame.setAttribute("allowfullscreen", "true");
    officeFrame.style.height = "100%";
    officeFrame.setAttribute(
      "sandbox",
      "allow-scripts allow-same-origin allow-forms allow-popups allow-top-navigation allow-popups-to-escape-sandbox"
    );

    return officeFrame;
  }

  handleLoadWOPI = () => {
    try {
      const form = this.prepareWopiForm(wopiViewerStore.data);
      const officeFrame = this.prepareWopiIframe();
      this.frameHolder.appendChild(officeFrame);
      this.frameHolder.appendChild(form);
      form.submit();
    } catch (error) {
      throw error;
    }
  };

  handleOpenInNewTab = (tokenInfo: API_WopiTokenInfo) => {
    const form = this.prepareWopiForm(tokenInfo);
    form.target = "_blank";
    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
  };

  handleFullScreen = () => this.handleOpenInNewTab(wopiViewerStore.data);

  handleEdit = async () => {
    try {
      const tokenInfo: API_WopiTokenInfo = await wopiViewerStore.fetchEditToken();
      this.handleOpenInNewTab(tokenInfo);
    } catch (error) {
      throw error;
    }
  };

  render() {
    return (
      <div className="online-viewer--wrap">
        <div
          id="frameholder"
          style={{
            position: "absolute",
            top: 0,
            bottom: 0,
            width: `100%`,
          }}
          ref={(ref) => (this.frameHolder = ref)}
        />
      </div>
    );
  }
}
export const WOPIViewerIframe = observer(WOPIViewerIframeClass);

// eslint-disable-next-line @typescript-eslint/no-empty-interface
interface WOPIViewerProps {}

export const WOPIViewer = observer(
  class WOPIViewer extends React.Component<WOPIViewerProps, { loading: boolean }> {
    private viewerRef: React.RefObject<WOPIViewerIframeClass>;
    constructor(props: WOPIViewerProps) {
      super(props);
      this.state = { loading: false };
      this.viewerRef = React.createRef();
    }

    doFullScreen = () => {
      if (this.viewerRef.current) {
        this.viewerRef.current.handleFullScreen();
        wopiViewerStore.hideModal();
      }
    };

    doEdit = async () => {
      if (this.viewerRef.current) {
        try {
          this.setState({ loading: true });
          await this.viewerRef.current.handleEdit();
        } catch (error) {
          throw error;
        } finally {
          this.setState({ loading: false });
        }
      }
    };

    render() {
      return (
        <ViewerModal
          title={wopiViewerStore.fileName}
          visible={wopiViewerStore.isVisible}
          onCancel={wopiViewerStore.hideModal}
          onFullScreen={this.doFullScreen}
        >
          {wopiViewerStore.state === "LOADING" ? <Loader /> : <WOPIViewerIframe ref={this.viewerRef} />}
        </ViewerModal>
      );
    }
  }
);
